// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assignment-history-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.auth-required {
  text-align: center;
  padding: 4rem 2rem;
  background: #f8f9fa;
  border-radius: 12px;
}

.auth-required h2 {
  color: #212529;
  margin-bottom: 1rem;
}

.auth-required p {
  color: #6c757d;
  font-size: 1.1rem;
}

.loading {
  text-align: center;
  padding: 4rem 2rem;
  font-size: 1.1rem;
  color: #6c757d;
}

.history-header {
  margin-bottom: 2rem;
}

.history-header h2 {
  font-size: 2rem;
  color: #212529;
  margin-bottom: 0.5rem;
}

.history-header p {
  color: #6c757d;
  font-size: 1rem;
}

.error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border: 1px solid #f5c6cb;
}

.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  background: #f8f9fa;
  border-radius: 12px;
}

.empty-state p {
  color: #6c757d;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}

.assignments-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.assignment-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.3s ease;
}

.assignment-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.assignment-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.assignment-card-header h3 {
  font-size: 1.25rem;
  color: #212529;
  margin: 0;
  flex: 1 1;
  margin-right: 1rem;
}

.assignment-date {
  font-size: 0.875rem;
  color: #6c757d;
  white-space: nowrap;
}

.assignment-summary {
  color: #6c757d;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.assignment-card-actions {
  display: flex;
  gap: 0.5rem;
}

.view-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.3s ease;
  flex: 1 1;
}

.view-btn:hover {
  background: #0056b3;
}

.delete-btn-small {
  background: #dc3545;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.3s ease;
}

.delete-btn-small:hover {
  background: #c82333;
}

.back-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  transition: background 0.3s ease;
}

.back-btn:hover {
  background: #5a6268;
}

.assignment-detail {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 2rem;
}

.assignment-detail h2 {
  color: #212529;
  margin-bottom: 0.5rem;
}

.assignment-detail .assignment-date {
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 2rem;
}

.detail-section {
  margin-bottom: 2rem;
}

.detail-section h3 {
  color: #212529;
  font-size: 1.25rem;
  margin-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 0.5rem;
}

.detail-section p {
  color: #495057;
  line-height: 1.8;
  margin-bottom: 1rem;
}

.assignment-text {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  border-left: 4px solid #007bff;
}

.assignment-text p {
  margin-bottom: 1rem;
  color: #212529;
}

.assignment-text p:last-child {
  margin-bottom: 0;
}

.detail-section ul {
  list-style: none;
  padding: 0;
}

.detail-section ul li {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  border-left: 4px solid #28a745;
}

.detail-section ul li strong {
  color: #212529;
}

.detail-section ul li p {
  margin-top: 0.5rem;
  margin-bottom: 0;
  color: #6c757d;
  font-size: 0.9rem;
}

.detail-actions {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e9ecef;
}

.delete-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.3s ease;
}

.delete-btn:hover {
  background: #c82333;
}

@media (max-width: 768px) {
  .assignment-history-container {
    padding: 1rem;
  }

  .assignments-list {
    grid-template-columns: 1fr;
  }

  .assignment-card-header {
    flex-direction: column;
  }

  .assignment-card-header .assignment-date {
    margin-top: 0.5rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/unAuth/components/AssignmentHistory.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".assignment-history-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.auth-required {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: #f8f9fa;\n  border-radius: 12px;\n}\n\n.auth-required h2 {\n  color: #212529;\n  margin-bottom: 1rem;\n}\n\n.auth-required p {\n  color: #6c757d;\n  font-size: 1.1rem;\n}\n\n.loading {\n  text-align: center;\n  padding: 4rem 2rem;\n  font-size: 1.1rem;\n  color: #6c757d;\n}\n\n.history-header {\n  margin-bottom: 2rem;\n}\n\n.history-header h2 {\n  font-size: 2rem;\n  color: #212529;\n  margin-bottom: 0.5rem;\n}\n\n.history-header p {\n  color: #6c757d;\n  font-size: 1rem;\n}\n\n.error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  border: 1px solid #f5c6cb;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: #f8f9fa;\n  border-radius: 12px;\n}\n\n.empty-state p {\n  color: #6c757d;\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n}\n\n.assignments-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.assignment-card {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 12px;\n  padding: 1.5rem;\n  transition: all 0.3s ease;\n}\n\n.assignment-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.assignment-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.assignment-card-header h3 {\n  font-size: 1.25rem;\n  color: #212529;\n  margin: 0;\n  flex: 1;\n  margin-right: 1rem;\n}\n\n.assignment-date {\n  font-size: 0.875rem;\n  color: #6c757d;\n  white-space: nowrap;\n}\n\n.assignment-summary {\n  color: #6c757d;\n  font-size: 0.95rem;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n}\n\n.assignment-card-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.view-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background 0.3s ease;\n  flex: 1;\n}\n\n.view-btn:hover {\n  background: #0056b3;\n}\n\n.delete-btn-small {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background 0.3s ease;\n}\n\n.delete-btn-small:hover {\n  background: #c82333;\n}\n\n.back-btn {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  margin-bottom: 1.5rem;\n  transition: background 0.3s ease;\n}\n\n.back-btn:hover {\n  background: #5a6268;\n}\n\n.assignment-detail {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 12px;\n  padding: 2rem;\n}\n\n.assignment-detail h2 {\n  color: #212529;\n  margin-bottom: 0.5rem;\n}\n\n.assignment-detail .assignment-date {\n  color: #6c757d;\n  font-size: 0.9rem;\n  margin-bottom: 2rem;\n}\n\n.detail-section {\n  margin-bottom: 2rem;\n}\n\n.detail-section h3 {\n  color: #212529;\n  font-size: 1.25rem;\n  margin-bottom: 1rem;\n  border-bottom: 2px solid #e9ecef;\n  padding-bottom: 0.5rem;\n}\n\n.detail-section p {\n  color: #495057;\n  line-height: 1.8;\n  margin-bottom: 1rem;\n}\n\n.assignment-text {\n  background: #f8f9fa;\n  padding: 1.5rem;\n  border-radius: 8px;\n  border-left: 4px solid #007bff;\n}\n\n.assignment-text p {\n  margin-bottom: 1rem;\n  color: #212529;\n}\n\n.assignment-text p:last-child {\n  margin-bottom: 0;\n}\n\n.detail-section ul {\n  list-style: none;\n  padding: 0;\n}\n\n.detail-section ul li {\n  background: #f8f9fa;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 0.5rem;\n  border-left: 4px solid #28a745;\n}\n\n.detail-section ul li strong {\n  color: #212529;\n}\n\n.detail-section ul li p {\n  margin-top: 0.5rem;\n  margin-bottom: 0;\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n.detail-actions {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid #e9ecef;\n}\n\n.delete-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background 0.3s ease;\n}\n\n.delete-btn:hover {\n  background: #c82333;\n}\n\n@media (max-width: 768px) {\n  .assignment-history-container {\n    padding: 1rem;\n  }\n\n  .assignments-list {\n    grid-template-columns: 1fr;\n  }\n\n  .assignment-card-header {\n    flex-direction: column;\n  }\n\n  .assignment-card-header .assignment-date {\n    margin-top: 0.5rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
